import React, { useState, useEffect } from 'react';
import { decodeEntities } from '@wordpress/html-entities';
import { useFilteredCategories } from '../../util/helper-functions';
import ICONS from '../icons';
import SitesSlider from '../sites-slider';
import GridSkeleton from '../sites-grid-skeleton';
import './style.scss';

const CategoryLayout = function( { config } ) {
	const {
		categories,
		enabledShowExcerpt,
		title,
		showAllUrl,
		pageBuilder,
		showWithDesc,
	} = config;
	const sites = useFilteredCategories( categories, pageBuilder, showWithDesc );
	const [ siteData, setSiteData ] = useState( {
		skeleton: true,
		sites,
	} );

	useEffect( () => {
		setSiteData( {
			...siteData,
			sites,
			skeleton: false,
		} );
	}, [] );

	const allSites = [];
	const pageSiteIds = [];
	if ( Object.keys( sites ).length ) {
		for ( const siteId in sites ) {
			if ( pageBuilder && pageBuilder !== sites[ siteId ][ 'astra-site-page-builder' ] ) {
				continue;
			}
			if ( pageSiteIds.includes( parseInt( sites[ siteId ][ 'astra-site-parent-id' ] ) ) ) {
				continue;
			}
			if ( pageSiteIds.includes( parseInt( sites[ siteId ].ecommerce_parent_template ) ) ) {
				continue;
			}
			pageSiteIds.push( parseInt( sites[ siteId ].id ) );
			allSites.push( {
				id: sites[ siteId ].id,
				image: '' !== sites[ siteId ][ 'seo-thumbnail-url' ] ? sites[ siteId ][ 'seo-thumbnail-url' ] : sites[ siteId ][ 'thumbnail-image-url' ],
				title: decodeEntities( sites[ siteId ].title ),
				desc: enabledShowExcerpt ? sites[ siteId ][ 'post-excerpt' ] : '',
				livelink:
					sites[ siteId ][ 'astra-site-live-url' ] + AstraShowcaseVars.customizerParam,
				badge: ( () => {
					if ( 'free' === sites[ siteId ][ 'astra-sites-type' ] ) {
						return '';
					}
					return sites[ siteId ][ 'astra-sites-type' ] === 'signature' ? ICONS.signature : ICONS.premium;
				} )(),
				...sites[ siteId ],
			} );
		}
	}

	return (
		<div id="st-showcase-category-slider-root">
			<h2 className="st-templates-category-title">{ decodeEntities( title ) }</h2>
			<div className={ `st-templates-category-slider-wrap ${ allSites.length > 0 ? '' : 'no-sites' }` }>
				{ siteData.gridSkeleton && <GridSkeleton column={ 3 } /> }
				{ ! siteData.gridSkeleton && allSites.length > 0 && (
					<>
						<a href={ showAllUrl } className="st-templates-category-link">See All</a>
						<SitesSlider sites={ allSites } columns={ 3 } />
					</>
				) }
				{ ! siteData.gridSkeleton && allSites.length === 0 && (
					<p className="no-sites-found">No sites found in this category.</p>
				) }
			</div>
		</div>
	);
};

export default CategoryLayout;
